import { render, staticRenderFns } from "./GestaoCarteira.vue?vue&type=template&id=38e78d3b"
import script from "./GestaoCarteira.vue?vue&type=script&lang=js"
export * from "./GestaoCarteira.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports